import { render, staticRenderFns } from "./AreaEditor.vue?vue&type=template&id=6e623550&"
import script from "./AreaEditor.vue?vue&type=script&lang=js&"
export * from "./AreaEditor.vue?vue&type=script&lang=js&"
import style0 from "./AreaEditor.vue?vue&type=style&index=0&id=6e623550&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports